import { InputProps } from '@chakra-ui/react';

export const solidWhite: InputProps = {
  borderColor: 'background.900',
  bgColor: 'white',
  color: 'text.900',
  _hover: {
    borderColor: 'secondary.50',
  },
  _focus: {
    bgColor: 'secondary.50',
    borderColor: 'secondary.50',
  },
};
